import React from 'react'

export default function Ecommerce() {
    window.location.href = "https://play.google.com/store/apps/details?id=co.fishshrimp";
    return (
        <></>
    )
}
